var render = function render(){var _vm=this,_c=_vm._self._c;return (this.page)?_c('div',[_c('i',{staticClass:"fa-regular fa-gear fa-lg cursor-pointer",on:{"click":_vm.showSettingsModal}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }